<template>
  <div class="replay_detail">
    <header>
      <a-row class="header">
        <a-col :span="3" class="header-right">
          <i @click="$router.go(-1)"></i>
        </a-col>
        <a-col :span="18" class="header-title">
          <span>{{ $t("workingWall.Comment") }}</span>
        </a-col>
      </a-row>
    </header>
    <mescroll-vue :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
      <div v-if="reply_detail.length != 0">
        <a-row
          class="comment_row"
          v-for="(reply, rindex) in reply_detail"
          :key="rindex"
        >
          <div @click="go_comment_detail(reply)">
            <a-col :span="4" class="comment_avator">
              <img
                :src="
                  (reply.user_head_img = '' ? reply.user_head_img : defaultImg)
                "
                alt
                :onerror="errorImg"
              />
            </a-col>
            <a-col :span="20">
              <a-row>
                <a-col :span="18" class="comment_author">{{
                  reply.user_name
                }}</a-col>
                <a-col :span="6" class="comment_time">{{
                  reply.created_at
                }}</a-col>
              </a-row>
              <a-row>
                <a-col :span="24" class="coment_content">{{ reply.txt }}</a-col>
              </a-row>
              <a-row>
                <a-col :offset="19" :span="5" class="comment_delete">
                  <i></i>
                  ({{ reply.reply_num }})
                </a-col>
              </a-row>
            </a-col>
          </div>
        </a-row>
      </div>
      <div class="no-data" v-else>
        <div v-show="isShow">
          <div class="no-img"></div>
          <h5>{{ $t("workingWall.length") }}</h5>
        </div>
      </div>
    </mescroll-vue>
    <!-- 回复 -->
    <div class="comment_footer">
      <input
        type="text"
        :placeholder="$t('workingWall.content')"
        class="commment_input"
        v-model="reply_value"
      />
      <a-button type="primary" class="comment_button" @click="reply_btn">{{
        $t("workingWall.Send")
      }}</a-button>
    </div>
  </div>
</template>
<script>
import MescrollVue from "mescroll.js/mescroll.vue";
import defaultImg from "../../assets/img/learning_camp/basic_fc.png";
export default {
  data() {
    return {
      defaultImg,
      errorImg:
        'this.src="' + require("@/assets/img/learning_camp/basic_fc.png") + '"',
      reply_detail: [],
      reply_value: "",
      mescroll: null, // mescroll实例对象
      mescrollDown: {
        textInOffset: this.$t("public.pullRefresh"),
        textOutOffset: this.$t("public.releaseRefresh"),
        textLoading: this.$t("public.loadtip"),
      }, // 下拉刷新的配置. (如果下拉刷新和上拉加载处理的逻辑是一样的,则mescrollDown可不用写了)
      mescrollUp: {
        htmlLoading: `<p class="upwarp-progress mescroll-rotate"></p><p class="upwarp-tip">${this.$t(
          "public.loadtip"
        )}</p>`,
        // 上拉加载的配置.
        callback: this.get_reply_detail,
        page: {
          num: 0, // 当前页 默认0,回调之前会加1; 即callback(page)会从1开始
          size: 10, // 每页数据条数,默认10
        },
        htmlNodata:
          '<p style="font-size:0.22rem">' +
          this.$t("workingWall.noMoreData") +
          "</p>",
      },
      submit: true,
      isShow: false,
      num: 1,
    };
  },

  components: {
    MescrollVue,
  },
  created() {
    // this.$i18n.locale = "zh";
  },
  methods: {
    // mescroll组件初始化的回调,可获取到mescroll对象
    mescrollInit(mescroll) {
      this.mescroll = mescroll; // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
    },
    get_reply_detail(page, mescroll) {
      var _this = this;
      var url = "index.php/mobile/homework/comment-list";
      var params = {
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        sys_id: localStorage.getItem("_sys_id"),
        language: localStorage.getItem("_user_data_language"),
        source_id: this.$route.query.id,
        page: page.num,
        size: page.size,
      };
      _this.$axios.post(url, params).then((res) => {
        if (res.data.code == 0) {
          if (page.num == 1) {
            _this.reply_detail = [];
          }
          if (res.data.result.list.length != 0) {
            _this.reply_detail = _this.reply_detail.concat(
              res.data.result.list
            );
          }
          // console.log(_this.reply_detail);
          _this.isShow = true;
          this.$nextTick(() => {
            mescroll.endByPage(
              res.data.result.pages.data_count,
              res.data.result.pages.page_count
            );
          });
        } else {
          if (res.data.code == 10600) {
            this.$router.push({ name: "Login" });
          } else {
            this.$toast(res.data.msg);
          }
        }
      });
    },
    reply_btn() {
      window.scroll(0, 0);
      var _this = this;
      if (_this.reply_value.trim() == "") {
        _this.$toast(_this.$t("workingWall.kong"));
        return false;
      }
      if (_this.reply_value.trim().length > 512) {
        _this.$toast(_this.$t("workingWall.over"));
        return false;
      }
      if (_this.reply_value.trim().length < 10) {
        _this.$toast(_this.$t("public.lessTen1"));
        return false;
      }
      if (_this.submit) {
        _this.submit = false;
        var url = "index.php/mobile/homework/add-comment";
        var params = {
          user_id: localStorage.getItem("_user_data_id"),
          company_id: localStorage.getItem("_user_data_company_id"),
          sso_token: localStorage.getItem("_user_data_sso_token"),
          sys_id: localStorage.getItem("_sys_id"),
          language: localStorage.getItem("_user_data_language"),
          source_id: this.$route.query.id,
          txt: _this.reply_value,
        };
        _this.$axios.post(url, params).then((res) => {
          // console.log(res);
          _this.submit = true;
          if (res.data.code == 0) {
            _this.$toast(_this.$t("workingWall.success"));
            _this.reply_value = "";
            _this.mescroll.resetUpScroll();
            _this.$store.commit("working_wall/comment_num", _this.num++);
            localStorage.setItem("num", _this.num++);
          } else {
            if (res.data.code == 10600) {
              this.$router.push({ name: "Login" });
            } else {
              this.$toast(res.data.msg);
            }
          }
        });
      }
    },
    go_comment_detail(cmt) {
      this.$router.push({
        path: "/main/commentDetail_workingWall",
        query: { kid: this.$route.query.id, did: cmt.id },
      });
    },
  },
};
</script>
<style scoped lang="less">
.mescroll {
  position: fixed;
  top: 0.8rem;
  bottom: 1.2rem;
  height: auto;
}

/*隐藏掉滚动条*/
.mescroll::-webkit-scrollbar {
  display: none;
}
header {
  height: 0.7rem;
}
.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 7;
  width: 100%;
  padding: 0.1rem 0.3rem;
  background: #f6f6f6;
  border-bottom: 0.01rem solid #ddd;
  display: flex;
  align-items: center;
  .header-title {
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      font-size: 0.32rem;
      color: #252631;
    }
    i {
      display: inline-block;
      width: 0.22rem;
      height: 0.03rem;
      background: #999999;
      margin: 0 0.1rem;
    }
  }
  .header-right {
    display: flex;
    align-items: center;
    i {
      display: inline-block;
      width: 0.18rem;
      height: 0.34rem;
      background: url("../../assets/img/facecourse/back.png") no-repeat
        center/contain;
      background-size: 100%;
    }
  }
}
.replay_detail {
  height: 100%;
  .comment_row {
    margin: 0.3rem;
    padding-bottom: 0.3rem;
    border-bottom: 1px solid #eee;
    .comment_avator {
      img {
        width: 0.76rem;
        height: 0.76rem;
        border-radius: 50%;
        pointer-events: none; //防止图片点击放大
      }
    }
    .comment_author {
      font-size: 0.26rem;
      color: #252631;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .comment_time {
      font-size: 0.22rem;
      color: #7f8485;
    }
    .coment_content {
      font-size: 0.26rem;
      color: #7f8485;
    }
    .comment_delete {
      font-size: 0.26rem;
      i {
        display: inline-block;
        width: 0.23rem;
        height: 0.23rem;
        background: url("../../assets/img/working-wall/comment.png") no-repeat
          center/contain;
        background-size: 100%;
        margin-right: 0.05rem;
        vertical-align: middle;
      }
    }
  }
  .no-data {
    .no-img {
      width: 2.75rem;
      height: 2.75rem;
      background: url("~@/assets/img/new/no-date.png") no-repeat center/contain;
      background-size: 100%;
      margin: 1rem auto;
      margin-bottom: 0.5rem;
    }
    h5 {
      text-align: center;
    }
  }
  .comment_footer {
    background: #f6f6f6;
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
    padding: 0.21rem 0.3rem;

    .commment_input {
      height: 0.8rem;
      width: 100%;
      font-size: 0.26rem;
      border: 1px solid #eee;
      padding-left: 0.1rem;
    }
    .comment_button {
      margin-left: 0.1rem;
      height: 0.8rem;
      width: 1.5rem;
      font-size: 0.3rem;
    }
  }
}
</style>
